// src/com/auto_plan_upload/AutoPlanUploadRow.js
import React, { useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { IconButton, Tooltip } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { AppObject, AppStyle, AppWord, TopCode } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';
import { useMutation } from '@apollo/client';
import { REMOVE_AUTO_PLAN, SAVE_AUTO_PLAN } from '../auto_plan/AutoPlanGql';
import { useConfirmDialog } from '../../common/AppConfirmDialog';
import { useAlertSetter, useAuthorizationCheck } from '../../api/app-hook';
import AutoPlanInput from '../auto_plan/AutoPlanInput';
import AutoPlanBindInput from '../auto_plan_bind/AutoPlanBindInput';
import { AutoPlanBindDictionary } from '../auto_plan_bind/AutoPlanBindDict';
import { REMOVE_AUTO_PLAN_BIND, SAVE_AUTO_PLAN_BIND } from '../auto_plan_bind/AutoPlanBindGql';

const LabelStyle={
    autoIRMiddleBlueBold : {
        color:'blue',
        fontWeight:'bold',
    },
    autoIRsmall : {
        fontSize:10
    },
    autoIRSmallBold :{
        fontSize:10,
        fontWeight:'bold'
    },
    autoIRMiddle: {
        fontSize:11
    },
    autoIRMiddleRedBold:{
        color: '#ff3600',
        fontWeight:'bold'
    },
    autoIRBig:{
        //fontSize:12
    },
    autoIRBigBold:{
        //fontSize:12,
        fontWeight:'bold'
    },
    autoIrPtYellow : {
        width:'100%',
        backgroundColor:'yellow',
        color:'red',
        //fontSize:12,
        fontWeight:'bold',
        borderRadius:5,
        paddingRight:5
    },
    autoIrPtRed:{
        width:'100%',
        backgroundColor:'red',
        color:'yellow',
        //fontSize:12,
        fontWeight:'bold',
        borderRadius:5,
        paddingRight:5
    },
    autoIrPtNormal:{
        width:'100%',
        //fontSize:12,
        fontWeight:'bold',
        color:'red',
        paddingRight:5
    },
    /*자동배차 호차 */
    autoHochaChangeGood: {
        width:'100%',
        backgroundColor: 'red', // borderRadius:3,
        paddingLeft:2, paddingRight:2,
        color:'white'
    },
    autoHochaNextDay:{
        width:'100%',
        backgroundColor: '#ffd38a', padding: '0 2px 0 2px'
    },
    autoHochaTransFragY:{
        width:'100%', border: '2px solid #2962a4', padding: '0 2px 0 2px'
    },
    autoNoneStyle:{
        width:'100%', padding: '0 2px 0 2px', backgroundColor: '#e9e9e9'
    },
    autoBlankStyle:{
        width:'100%', padding: '0 2px 0 2px',
    },
    rowStyle1:{
        backgroundColor: '#FAF8F8'
    },
    rowStyle2:{
        backgroundColor: '#FFFFFF'
    },
    // new
    red: {color:'red'},
    blue: {color:'blue'},
};

const TableRow = styled('tr')({
    borderBottom: '1px solid #eee',
    padding: 0,
});

const LeftBold100 = {width:'100%', textAlign:'left',fontWeight:'bold'};
const CenterBold100 = {width:'100%', textAlign:'center',fontWeight:'bold'};

const ValueCell = styled('td')({
    padding: '2px 5px 2px 5px', fontSize: '0.75rem'
});

const CC = styled('div')({
    // Cell Content
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    padding: 0
})

const Boxel = ({children, style, ccStyle, onMouseEnter, onMouseLeave, onDoubleClick}) => {
    return(
        <ValueCell style={style}
            onMouseEnter={(e)=>{if(onMouseEnter) onMouseEnter(e)}}
            onMouseLeave={(e)=>{if(onMouseLeave) onMouseLeave(e)}}
            onDoubleClick={(e)=>{if(onDoubleClick) onDoubleClick(e)}}
        >
            <CC style={ccStyle}>
                {children}
            </CC>
        </ValueCell>
    )
};

const Cell = styled('div')({
    padding:0
});

const Blank = <span>&nbsp;</span>

const hhmm = (h2m2) => {
    if(h2m2) {
        const t = h2m2.padStart(4, '0');
        return t.substr(0,2) + ':' + t.substr(2,2);
    }
    return '';
};

const BindCell = ({bindIndex, bindInfo, canDeliver, onClickEdit, onClickRemove}) => {
    const [mouseOver, setMouseOver] = useState(false);

    return(
        <Boxel style={{borderRight:AppStyle.BorderCCC, position:'relative'}}
            onMouseEnter={(e)=>setMouseOver(true)}
            onMouseLeave={(e)=>setMouseOver(false)}
        >
            {
                mouseOver && canDeliver &&
                <div style={{
                        position:'absolute', bottom:3, right: 0, zIndex:12,
                        display:'flex', justifyContent:'space-between',
                        backgroundColor:"rgba(255,255,255,0.7)",
                        border:'1px solid #f00', borderRadius:5,
                    }}
                >
                    <Tooltip
                        title={bindInfo ? '수정' : '추가'}
                    >
                        <IconButton
                            onClick={()=>onClickEdit(bindIndex, bindInfo)}
                            size={AppWord.SMALL}
                            color={AppStyle.mui.primary}
                        >
                            {bindInfo ? <EditIcon /> : <LibraryAddIcon />}
                        </IconButton>
                    </Tooltip>
                    {
                        bindInfo &&
                        <Tooltip
                            title='삭제'
                        >
                            <IconButton
                                onClick={()=>onClickRemove(bindIndex, bindInfo)}
                                size={AppWord.SMALL}
                                color={AppStyle.mui.warning}
                            >
                                <DeleteForeverIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
            }
            {bindInfo &&
            <>
            <Cell style={LabelStyle.blue}>{bindInfo.targetStoreId}</Cell>
            <Cell style={LabelStyle.blue}>{bindInfo.targetHocha.toString().padStart(3,'0')}</Cell>
            <Cell>&nbsp;</Cell>
            <Cell style={LabelStyle.blue}>{bindInfo.bindStoreId}</Cell>
            <Cell style={LabelStyle.blue}>{bindInfo.bindHocha.toString().padStart(3,'0')}</Cell>
            </>
            }
        </Boxel>
    );
}

const PlanCell = ({item, hocha, plan, canDeliver, onClickEdit, onClickRemove, onClickAdd}) => {
    const [mouseOver, setMouseOver] = useState(false);

    if(!plan || !item.planDate) {
        return <Boxel> </Boxel>;
    }
    const planStyle = plan.tsrPrinted ? LabelStyle.autoHochaTransFragY : LabelStyle.autoNoneStyle;
    const typeStyle
    = ValueMisc.isAnsungOrHaman(plan.dcCd)
    ?
    (
        plan.vehPlates ? LabelStyle.autoNoneStyle : LabelStyle.autoHochaChangeGood
    )
    :
    plan.chargeGood ? LabelStyle.autoHochaChangeGood : LabelStyle.autoNoneStyle;

    if(!plan.hocha) {
        return (
            <Boxel ccStyle={LabelStyle.autoBlankStyle}
            >
                <div>
                    <Cell style={{width:'100%', textAlign:'center'}}>
                        {
                            plan.canAdd && canDeliver &&
                            <Tooltip
                                title={`${item && item.storeName} ${hocha}호차 추가`}
                            >
                                <IconButton
                                    onClick={()=>onClickAdd(hocha)}
                                    size={AppWord.SMALL}
                                    color={AppStyle.mui.primary}
                                    disabled={!item}
                                >
                                    <AddBoxIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </Cell>
                </div>
            </Boxel>
        );
    }
    return(
        <Boxel ccStyle={{...planStyle, position:'relative'}}
            onMouseEnter={(e)=>setMouseOver(true)}
            onMouseLeave={(e)=>setMouseOver(false)}
        >
            {
                mouseOver && canDeliver &&
                <div style={{
                        position:'absolute', bottom:3, zIndex:10,
                        width:'100%', display:'flex',
                        justifyContent:'space-between',
                        backgroundColor:"rgba(255,255,255,0.7)",
                        border:'1px solid #f00', borderRadius:5,
                    }}
                >
                    <Tooltip
                        title={`${item && item.storeName} ${hocha}호차 ${plan.vehTypeId ? '수정' : '재입력'}`}
                    >
                        <IconButton
                            onClick={()=>onClickEdit(plan)}
                            size={AppWord.SMALL}
                            color={AppStyle.mui.primary}
                        >
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                    {plan.vehTypeId &&
                        <Tooltip title={`${item && item.storeName} ${hocha}호차 삭제`}>
                            <IconButton
                                onClick={()=>onClickRemove(plan)}
                                size={AppWord.SMALL}
                                color={AppStyle.mui.warning}
                            >
                                <DeleteForeverIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
            }
            <div style={typeStyle}>
                <Cell style={CenterBold100}>
                    {plan.vehTypeId ? plan.vehTypeAlias : '삭제됨'}
                </Cell>
                <Cell style={LeftBold100}>
                    {plan.shprTime ? plan.shprTime.substring(0,5) : Blank}
                </Cell>
            </div>
            <div style={plan.nextDay ? LabelStyle.autoHochaNextDay : LabelStyle.autoNoneStyle}>
                <Cell style={{width:'100%', textAlign:'center', color:"blue",fontWeight:'bold'}}>
                    {plan.startTime ? plan.startTime.substring(0,5) : '🕗'}
                </Cell>
                <Cell style={{width:'100%', textAlign:'right', color:'red',fontWeight:'bold'}}>
                    {plan.arriveTime ? plan.arriveTime.substring(0,5) : Blank}
                </Cell>
                <Cell style={LeftBold100}>
                    {plan.returnTime ? plan.returnTime.substring(0,5) : Blank}
                </Cell>
            </div>
        </Boxel>
    );
};

/**
 * 상온자동배차의 점포별 레코드를 출력. Table Row 하나.
 * @param {*} param0 
 * @returns 
 */
export default function AutoPlanUploadRow({
    item, // item이 null 이면 빈 행 출력.
    canDeliver, // 호차관리, 동적관리 등을 할 수 있음.
    onRequestReload, // 저장 후 재조회 요청
}) {
    const [editorState, setEditorState] = useState(AppObject.EmptyViewerState);
    const [bindEditState, setBindEditState] = useState(AppObject.EmptyViewerState);
    const openConfirmDialog = useConfirmDialog();
    const checkAuth = useAuthorizationCheck();
    const addAlert = useAlertSetter();
    const [saveAutoPlan, responseSave] = useMutation( SAVE_AUTO_PLAN, {
        onCompleted: (data, option) => onCompleteSave(data, option), 
        onError: (error) => addAlert({title: "자동배차 저장 오류", message: [error.message]})
    } );
    const [removeAutoPlan, responseRemove] = useMutation( REMOVE_AUTO_PLAN, {
		onCompleted: (data, option) => onCompleteRemove(data, option),
		onError: (error) => addAlert({title: "자동배차 삭제 오류", message: [error.message]})
	});
    // 동적
    const [saveAutoPlanBind, responseSaveBind] = useMutation( SAVE_AUTO_PLAN_BIND, {
		onCompleted: (data, option) => onCompleteSaveBind(data, option),
		onError: (error) => addAlert({title: AutoPlanBindDictionary.errorTitle.Add, message: [error.message]})
	} );
    const [removeAutoPlanBind, responseRemoveBind] = useMutation( REMOVE_AUTO_PLAN_BIND, {
		onCompleted: (data, option) => onCompleteRemoveBind(data, option),
		onError: (error) => addAlert({title: AutoPlanBindDictionary.errorTitle.Remove, message: [error.message]})
	});
    const resOverPtStyle = useMemo(()=>{
        if(item) {
            if(item.restOverPt >= 3) return LabelStyle.autoIrPtYellow;
            if(item.nextday04Pt + item.restOverPt <= -3) return LabelStyle.autoIrPtRed;
            return LabelStyle.autoIrPtNormal;
        }
        return null;
    }, [item]);

    const plans = useMemo(()=>{
        if(item) {
            const ten = Array(10).fill({});
            let lastIndex = -1;
            if(item.plans) {
                item.plans.forEach((plan)=>{
                    if(plan.hocha) {
                        const idx = plan.hocha-1;
                        if(idx<10) {
                            ten[idx] = plan;
                            if(idx > lastIndex) lastIndex = idx;
                        }
                    }
                })
            }
            // 최종 인덱스 다음 인덱스가 9보다 작으면 그 다음 호차(인덱스+1)는 추가가 가능하다.
            if(lastIndex < 9) {
                ten[lastIndex+1] = {canAdd:true};
            }
            return ten;
        }
        return Array(10).fill({});
    }, [item]);


    const onCompleteSave = (data, clientOption) => {
        if(data.autoPlanSave.ok) {
            setEditorState(AppObject.EmptyViewerState);
            onRequestReload();
        }
        else addAlert({title:"자동배차 저장 오류", message:[data.autoPlanSave.message]});
    };

    const onCompleteRemove = (data, clientOption) => {
        if(data.autoPlanRemove.ok) onRequestReload();
        else addAlert({title:"자동배차 삭제 오류", message:[data.autoPlanRemove.message]});
    };

    // 동적
    const onCompleteSaveBind = (data, clientOption) => {
        if(data.autoPlanBindSave.ok) {
            setBindEditState(AppObject.EmptyViewerState);
            onRequestReload();
        }
        else addAlert({title:AutoPlanBindDictionary.errorTitle.Add, message:[data.autoPlanBindSave.message]});
    };

    const onCompleteRemoveBind = (data, clientOption) => {
        if(data.autoPlanBindRemove.ok) onRequestReload();
        else addAlert({title:AutoPlanBindDictionary.errorTitle.Remove, message:[data.autoPlanBindRemove.message]});
    };


    const onClickAddHocha = (hocha) => {
        console.log('onClickAddHocha', hocha);
        setEditorState({open:true, item:null, hocha: hocha});
    };

    const onClickEditHocha = (plan) => {
        console.log('onClickEditHocha', plan.hocha);
        setEditorState({open:true, item:plan, hocha: plan.hocha});
    };

    const confirmRemoveHocha = async (param) => {
        const confirm = await openConfirmDialog({
            title: "자동배차 삭제",
            content: [
                `자동배차 ${param.hocha}호차를 삭제하시겠습니까?`,
                '삭제 후 복구할 수 없습니다. 계속하시겠습니까?'
            ]
        });

        if(confirm) removeAutoPlan({variables:{autoPlan:param}});
    };

    const onClickRemoveHocha = (plan) => {
        const param = {
            arriveId: item.arriveId,
            dcCd: item.dcCd,
            planDate: item.planDate,
            hocha: plan.hocha
        }
        confirmRemoveHocha(param);
    };

    const onRequestEditBindInfo = (bindIndex, bindInfo) => {
        if(item) setBindEditState({open:true, item:bindInfo, bindIndex: bindIndex});
    };

    const onRequestRemoveBindInfo = async (bindIndex, bindInfo) => {
        const confirm = await openConfirmDialog({
            title: "동적배차 삭제",
            content: [
                `동적배차(${bindIndex}번, ${bindInfo.targetStoreId} + ${bindInfo.bindStoreId})를 삭제합니다.`,
                '계속하시겠습니까?'
            ]
        });

        if(confirm) {
            const param = {
                dcCd: bindInfo.dcCd,
                planDate: bindInfo.planDate,
                bindIndex: bindInfo.bindIndex,
                targetStoreId: bindInfo.targetStoreId,
            }
            removeAutoPlanBind({variables:{autoPlanBind:param}});
        }
    }

    const onRequestSaveBindInfo = (bindInfo, isEdit) => {
        const mutateParam = {variables:{autoPlanBind:bindInfo}};
        saveAutoPlanBind(mutateParam);
    };

    const onRequestSavePlan = (plan, isEdit) => {
        saveAutoPlan({variables:{autoPlan: plan}});
    };

    /* const renderPlans = () => {
        return plans.map((plan, idx)=>{
            return <PlanCell key={idx}
                item={item}
                hocha={idx+1}
                plan={plan}
                onClickAdd={onClickAddHocha}
                onClickEdit={onClickEditHocha}
                onClickRemove={onClickRemoveHocha}
            />
        });
    }; */

    if(!item) {
        return(
            <TableRow>
                <ValueCell colSpan={26}>
                    <CC style={{color:'transparent'}}>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                    </CC>
                </ValueCell>
            </TableRow>
        );
    }

    return(
        <TableRow hover
            style={
                item.dcCd===TopCode.DcCode.Adc982 && TopCode.ADCStoresToStare.includes(item.storeId) ?
                {backgroundColor: '#fdff98'} : {}
            }
        >
            <Boxel>{item.basicDockno}</Boxel>
            <Boxel>
                <Cell style={
                    item.lastShipTime === '1600' ? LabelStyle.autoIRMiddleBlueBold : 
                    (
                        ((item.mainVehTypeName === 'T' || item.mainVehTypeName === 'D' || item.mainVehTypeName === 'T-') &&
                        (item.maxVehTypeName === 'T' || item.maxVehTypeName === 'D' || item.maxVehTypeName === 'T-')) ? 
                        LabelStyle.autoIRMiddleRedBold : LabelStyle.autoIRBigBold
                    )
                }>{item.storeName}</Cell>
                <Cell>{item.storeId}</Cell>
            </Boxel>
            <Boxel>
                <Cell><b>{hhmm(item.firstShipTime)}</b></Cell>
                <Cell><b style={LabelStyle.red}>{hhmm(item.lastShipTime)}</b></Cell>
                <Cell>
                    {item.mainVehTypeName}/{item.maxVehTypeName}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>
                    {item.distanceOne}
                </Cell>
                <Cell>
                    {hhmm(item.basicExpectRunTime)}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>
                    {item.leftOver || '-'}
                </Cell>
            </Boxel>
            <Boxel>
                {ValueMisc.float2str(item.totVol)}
            </Boxel>
            <Boxel>
                <Cell>{item.nBulkPt ? item.nBulkPt : '-'}</Cell>
                <Cell>{item.yBulkPt ? item.yBulkPt : '-'}</Cell>
                <Cell style={LabelStyle.blue}>{item.oBulkPt ? item.oBulkPt : '-'}</Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.blue}>{item.pbsPt15 || '-'}</Cell>
                <Cell style={{color:'red', fontSize:'0.6rem'}}>
                    {item.storeCpp || '-'}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>{item.dayPt18 || '-'}</Cell>
            </Boxel>
            <Boxel style={{borderRight:AppStyle.BorderCCC}}>
                <Cell style={LabelStyle.red}>{item.dayPt04 || '-'}</Cell>
                <Cell style={LabelStyle.red}>{item.dayPt11 || '-'}</Cell>
                <Cell style={LabelStyle.red}>{item.dayPt15 || '-'}</Cell>
            </Boxel>
            <BindCell bindIndex={1} bindInfo={item.bindOne}
                canDeliver={canDeliver}
                onClickEdit={onRequestEditBindInfo}
                onClickRemove={onRequestRemoveBindInfo}
            />
            <BindCell bindIndex={2} bindInfo={item.bindTwo}
                canDeliver={canDeliver}
                onClickEdit={onRequestEditBindInfo}
                onClickRemove={onRequestRemoveBindInfo}
            />
            <Boxel>
                <Cell style={LabelStyle.autoIRBigBold}>{item.comName.substring(0,6)}</Cell>
                <Cell style={{fontSize:'0.6rem'}}>{item.loadMaxCnt || '-'}</Cell>
                <Cell style={LabelStyle.blue}>{item.didaNote}</Cell>
            </Boxel>
            <Boxel>
                <Cell style={{textAlign:'right', width: '60%'}}>
                    <Cell>{item.totalPt}</Cell>
                    <Cell style={resOverPtStyle}>{item.restOverPt}</Cell>
                    <Cell>{item.nextday04Pt}</Cell>
                </Cell>
            </Boxel>
            <Boxel>
                <Cell>차종</Cell>
                <Cell>접안</Cell>
                <Cell>출발</Cell>
                <Cell>도착</Cell>
                <Cell>복귀</Cell>
            </Boxel>
            {plans.map((plan, idx)=>{
                return <PlanCell key={idx}
                    item={item}
                    hocha={idx+1}
                    plan={plan}
                    canDeliver={canDeliver}
                    onClickAdd={onClickAddHocha}
                    onClickEdit={onClickEditHocha}
                    onClickRemove={onClickRemoveHocha}
                />
            })}
            <Boxel>
                {/* 노트가 없는디 */}
            </Boxel>
            <AutoPlanInput
                open={editorState.open}
                hocha={editorState.hocha}
                item={editorState.item}
                autoPlanUploadItem={item}
                onClose={() => setEditorState(AppObject.EmptyViewerState)}
                responseSave={responseSave}
                onRequestSave={onRequestSavePlan}
            />
            <AutoPlanBindInput
                open={bindEditState.open}
                baseData={item}
                bindIndex={bindEditState.bindIndex}
                item={bindEditState.item}
                onClose={() => setBindEditState(AppObject.EmptyViewerState)}
                onRequestSave={onRequestSaveBindInfo}
                responseSaving={responseSaveBind}
            />
        </TableRow>
    );
}